import { ReactElement } from 'react';
import { isEmpty } from 'ramda';

export type ObjectOrObjectArrayOrNull = Object | ObjectArrayOrNull;
export type ObjectArrayOrNull = Object[] | null;
export type ObjectArray = Object[];
export type ObjectOrNull = Object | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const isString = (x: any): x is string => {
  return typeof x === 'string';
};

export const isStringOrFalsy = (x: any): x is string => {
  return typeof x === 'string' || !x;
};

export const isObjectTruthy = (obj: Object | null): obj is Object => {
  return Boolean(obj && Object.keys(obj).length > 0);
};

export const isReactComponent = (x: any): x is ReactElement<any> => {
  // tslint:disable-next-line
  return (<ReactElement<any>>x).props !== undefined;
};

export const nullIfEmpty = (arr: any) => {
  return Array.isArray(arr) && isEmpty(arr) ? null : arr;
};
